import React from 'react';


const Professional = () => {
  return (
    <section className="professional" id="professional">
      <header className="text-center">
        <h2><span className="index">01</span> PROFESSIONAL</h2>
        <p>MY KNOWLEDGE LEVEL IN SOFTWARE</p>
      </header>
      <main className="container">
        <div className="row">
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/html.png" alt="html" width="30px" />
                  <span className="ml-2">HTML</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/css.png" alt="css" width="30px" />
                  <span className="ml-2">CSS</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/javascript.png" alt="javascript" width="30px" />
                  <span className="ml-2">JavaScript</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/typescript.png" alt="typescript" width="30px" />
                  <span className="ml-2">TypeScript</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/rwd.png" alt="rwd" width="30px" />
                  <span className="ml-2">RWD</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/bootstrap.png" alt="bootstrap" width="30px" />
                  <span className="ml-2">Bootstrap</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/jquery.png" alt="jquery" width="30px" />
                  <span className="ml-2">jQuery</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/sass.png" alt="sass" width="30px" />
                  <span className="ml-2">Sass</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/react.png" alt="react" width="30px" />
                  <span className="ml-2">React.JS</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/angular.png" alt="react" width="30px" />
                  <span className="ml-2">Angular</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/node.png" alt="node" width="30px" />
                  <span className="ml-2">Node.JS</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                    <i className="far fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/express.png" alt="express" width="30px" />
                  <span className="ml-2">Express.JS</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                    <i className="far fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/gulp.png" alt="gulp" width="30px" />
                  <span className="ml-2">Gulp</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                    <i className="far fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-4 col-lg-3 mt-4">
            <div className="card">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="tech d-flex align-items-center">
                  <img src="./logos/git.png" alt="git" width="30px" />
                  <span className="ml-2">Git</span>
                </div>
                <div className="level">
                  <span>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                    <i className="far fa-star"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </section>
  );
}

export default Professional;
